<template>
  <v-row class="py-0 my-0 d-flex">
    <v-col
      v-for="(value, side) in values"
      :key="side"
      class="py-0 my-0"
      @click="sideSelected(side)"
    >
      <v-text-field
        v-if="!readOnly"
        :value="value || $t('label.no_value')"
        :label="label"
        disabled
        dense
        hide-details
        rounded
        style="pointer-events: none"
        :class="`side-picker pt-4 ${side === selectedSide ?
          ($vuetify.theme.dark ? 'green lighten-3 selected' : 'green lighten-5 selected') :
          ($vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4')}`"
      />
      <div
        v-else
        class="d-flex"
        style="pointer-events: none"
      >
        <div style="min-width: 19%; display: block-inline">
          {{ label }}:
        </div>
        <span class="font-weight-medium">{{ value }}</span>
      </div>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import DialogClosable from '@/mixins/dialog-closable';

export default Vue.extend({
  name: 'ContactsMergeRow',
  components: { },
  mixins: [DialogClosable],
  props: {
    field: { type: String as PropType<string>, required: true },
    label: { type: String as PropType<string>, required: true },
    values: { type: Object as PropType<Array<string|number|boolean>>, required: true },
    selectedSide: { type: Number as PropType<number>, required: true },
    readOnly: { type: Boolean as PropType<boolean>, required: false, default: false },
  },
  data() {
    return { };
  },
  computed: { },
  watch: { },
  methods: {
    sideSelected(side: number) {
      if (this.readOnly) return;
      this.$emit('side-selected', { field: this.field, side });
    },
  },
});
</script>

<style scoped lang="scss">
.side-picker {
  border-radius: 8px;

  &.selected ::v-deep(.v-label) {
    color: $grey-90-color !important;
  }

  &.selected ::v-deep(input) {
  color: $black-color !important;
  }
}

</style>
